// Code generated by protoc-gen-weave-ts. DO NOT EDIT.
export var Direction;
(function (Direction) {
    Direction["DIRECTION_UNKNOWN"] = "DIRECTION_UNKNOWN";
    Direction["DIRECTION_INBOUND"] = "DIRECTION_INBOUND";
    Direction["DIRECTION_OUTBOUND"] = "DIRECTION_OUTBOUND";
})(Direction || (Direction = {}));
export var Direction_index;
(function (Direction_index) {
    Direction_index[Direction_index["DIRECTION_UNKNOWN"] = 0] = "DIRECTION_UNKNOWN";
    Direction_index[Direction_index["DIRECTION_INBOUND"] = 1] = "DIRECTION_INBOUND";
    Direction_index[Direction_index["DIRECTION_OUTBOUND"] = 2] = "DIRECTION_OUTBOUND";
})(Direction_index || (Direction_index = {}));
export var CallStatus;
(function (CallStatus) {
    CallStatus["CALL_STATUS_UNKNOWN"] = "CALL_STATUS_UNKNOWN";
    CallStatus["CALL_STATUS_ANSWERED"] = "CALL_STATUS_ANSWERED";
    CallStatus["CALL_STATUS_ABANDONED"] = "CALL_STATUS_ABANDONED";
    CallStatus["CALL_STATUS_MISSED"] = "CALL_STATUS_MISSED";
    CallStatus["CALL_STATUS_FORWARDED"] = "CALL_STATUS_FORWARDED";
})(CallStatus || (CallStatus = {}));
export var CallStatus_index;
(function (CallStatus_index) {
    CallStatus_index[CallStatus_index["CALL_STATUS_UNKNOWN"] = 0] = "CALL_STATUS_UNKNOWN";
    CallStatus_index[CallStatus_index["CALL_STATUS_ANSWERED"] = 1] = "CALL_STATUS_ANSWERED";
    CallStatus_index[CallStatus_index["CALL_STATUS_ABANDONED"] = 2] = "CALL_STATUS_ABANDONED";
    CallStatus_index[CallStatus_index["CALL_STATUS_MISSED"] = 3] = "CALL_STATUS_MISSED";
    CallStatus_index[CallStatus_index["CALL_STATUS_FORWARDED"] = 4] = "CALL_STATUS_FORWARDED";
})(CallStatus_index || (CallStatus_index = {}));
